import { render, staticRenderFns } from "./RodrigoJubett.vue?vue&type=template&id=680a00b2"
import script from "./RodrigoJubett.vue?vue&type=script&lang=js"
export * from "./RodrigoJubett.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports